import React from 'react'
import { Box, Stack, styled, Typography } from '@mui/material'
import { getTerm } from '@app/helpers/workkeysReplaceTerms'

const testTermLower = getTerm('test')

interface SubmitModalContentProps {
  children: JSX.Element
  duration?: number
}

export const SubmitModalLayout: React.FC<SubmitModalContentProps> = ({ children, duration = 0 }) => {
  return (
    <>
      {children ? (
        <Stack gap={6}>
          <Stack gap={4}>
            <Typography variant="variation_subtitle1" component='p'>
              You will not be able to attempt any more questions once you submit.
            </Typography>
            <Stack gap={0}>
              <Typography variant="variation_subtitle1" component='p'>
                Unanswered questions are not shaded below.
              </Typography>
              <Typography variant="variation_subtitle1" component='p'>
                Click any bubble to return to that question.
              </Typography>
            </Stack>
          </Stack>
          <ItemsListBlock component='nav' aria-label='Question navigation'>
            <ItemsListTitle variant='h3'>Questions</ItemsListTitle>
            <ItemsListWrapper>{children}</ItemsListWrapper>
          </ItemsListBlock>
        </Stack>
      ) : (
        <Typography variant="variation_subtitle1" component='p'>
          {/* a11y: Trailing space lives inside the <b> so it's part of a real
              text node (NVDA won't announce "space"), and disappears cleanly
              when the conditional sentence isn't rendered. */}
          {duration > 0 && <b>You still have time left. </b>}
          {/* a11y: Add text in single template-literal expressions so NVDA reads each sentence as one continuous sentence */}
          {`You could take this time to review your ${testTermLower} answers.`}
        </Typography>
      )}
    </>
  )
}

const ItemsListBlock = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 6, 6),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  border: `1px solid ${theme.palette.grey[100]}`,
  borderRadius: '3px',
}))

const ItemsListTitle = styled(Typography)(({ theme }) => ({
  fontWeight: '600',
  marginBottom: theme.spacing(4),
}))

const ItemsListWrapper = styled('ul')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  listStyle: 'none',
  padding: 0,
  margin: 0,
}))
